/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllCourtsList } from "../../redux/Slice/Courts/CourtsListSlice";
import { ArchiveCourt } from "./ArchiveCourt";
import { toast } from "react-toastify";

const Courts = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { AllCourtsData, errorMessage } = useAppSelector((state) => state.courtsList);
  const { SelectedFacility } = useAppSelector(state => state.facilityList)
  const [archive, setArchive] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  useEffect(() => {
    dispatch(AllCourtsList({ facilityId: SelectedFacility }));
  }, [SelectedFacility]);

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Courts Name",
        accessor: "name",
      },
      {
        Header: "Facility",
        accessor: "facility",
      },
      {
        Header: "Sports",
        accessor: "sport",
      },
      {
        Header: "Timing",
        accessor: "timing",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const handleAdd = () => {
    navigate("/add-court");
  };

  const handleEdit = (id: string) => {
    navigate("/update-court", { state: id });
  };

  const handleUserInfo = (id: string) => {
    navigate("/court-info", { state: id });
  };

  const HandleDelete = (id: string) => {
    setArchive(true);
    setDeleteId(id);
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Courts List</Card.Title>
            <ButtonGroup>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Court"
                name="add-court"
                id="add-court"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table
          columns={columns}
          data={AllCourtsData}
          handleEdit={handleEdit}
          HandleShow={handleUserInfo}
          HandleDelete={HandleDelete}
        />
        <ArchiveCourt setArchive={setArchive} archive={archive} id={deleteId} />
      </Card>
    </>
  );
};
export { Courts };
